import { ARTICLE_FEATURED_TYPES } from '../../constants'

export function isFeatured (type = '') {
  return ARTICLE_FEATURED_TYPES.indexOf(type) !== -1
}
